export const AVERAGE_HOME_CARBON_KG_FROM_ELECTRICITY = 463.53;
export const AVERAGE_HOME_CARBON_KG_FROM_GAS = 1177.94;
export const AVERAGE_HOME_CARBON_KG_TOTAL = 1641.47;
